import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { useTranslate } from '../../../../../../../../hooks/useTranslate';
import { SendButton, StyledForm, TextArea } from './Form.styles';
import type { FormInput, Props } from './Form.types';

export const Form = ({
  isLoading,
  onInputInitiated,
  onSubmit,
  initialPrompt,
}: Props) => {
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    formState: { isValid, isDirty },
    reset,
    getValues,
    setFocus,
  } = useForm<FormInput>({
    defaultValues: {
      prompt: initialPrompt,
    },
  });
  const isDesktop = useMediaQuery('(min-width:600px)');

  const isFormDisabled = !isValid || isLoading;

  const submit = async () => {
    if (isFormDisabled) return;
    const values = getValues();
    reset({ prompt: '' });
    return onSubmit(values);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      return submit();
    }
  };

  useEffect(() => {
    if (isDirty) {
      onInputInitiated();
    } else if (isDesktop) {
      setFocus('prompt');
    }
  }, [setFocus, isDirty]);

  return (
    <StyledForm onSubmit={handleSubmit(submit)}>
      <TextArea
        maxRows={3}
        placeholder={t('explore.amelia.textarea.placeholder')}
        aria-label={t('explore.amelia.textarea.label')}
        onKeyDown={onKeyDown}
        {...register('prompt', {
          required: true,
          setValueAs: (value) => value.trim(),
        })}
      />

      <SendButton type="submit" variant="important" disabled={isFormDisabled}>
        {t('explore.amelia.sendButton.label')}
      </SendButton>
    </StyledForm>
  );
};
